export enum ScenarioActionTypes {
	NEW_STAGE = "NEW_STAGE",
	FINISH_SCENARIO = "FINISH_SCENARIO",
	SHOW_SPOILER = "SHOW_SPOILER",
	REMOVE_USER = "REMOVE_USER",
	RESTART_SCENARIO = "RESTART_SCENARIO",
	LOGOUT = "LOGOUT",
}
